window.global ||= window; // https://github.com/vitejs/vite/issues/2778#issuecomment-810086159

import React from "react";
import { createRoot } from "react-dom/client";

import { RouterProvider } from "react-router";

import { BootstrapErrorFallback } from "app/components/fallbacks";
import { ConfigProvider } from "app/contexts";
import { ApiExplorerProvider } from "app/contexts/ApiExplorerContext";
import { ThemeProvider as ColorSchemeProvider } from "app/contexts/ThemeContext";
import { primeSubscriptionClient } from "app/utils/subscriptionClient";

import { createAppRouter } from "./Routes";
import { startConsole } from "./startup";

// Resolve the config and build the subscriptions client once at startup, so
// the first view to subscribe only has the socket left to open. graphql-ws
// connects lazily, on that first subscription.
// Called here rather than at RelayEnvironment's module scope: that module is
// imported by component tests, and a connect-and-retry-forever side effect on
// import made the suite flaky.
primeSubscriptionClient();

// Supports weights 100-900
import "@fontsource-variable/dm-sans";
// Weight 400 only
import "@fontsource/dm-mono";

const container = document.getElementById("root");
// eslint-disable-next-line typescript/no-non-null-assertion
const root = createRoot(container!);

function renderApp() {
  const router = createAppRouter();

  root.render(
    <React.StrictMode>
      <ConfigProvider>
        <ApiExplorerProvider>
          <ColorSchemeProvider>
            <RouterProvider router={router} />
          </ColorSchemeProvider>
        </ApiExplorerProvider>
      </ConfigProvider>
    </React.StrictMode>,
  );
}

startConsole({
  app: renderApp,
  error: () => root.render(<BootstrapErrorFallback />),
});
